import { Outlet, Navigate } from "react-router-dom";
import authService from "../features/auth/authService";

function PublicRoutes() {
    let isLoggedIn = authService.isLoggedIn();
    let role = authService.getRole();
    return (
          !isLoggedIn ? <Outlet/> : role === 'admin' ? <Navigate to='/coordinator'/> : <Navigate to='/home'/>
    )
}

export default PublicRoutes